export default __webpack_public_path__ + "static/media/tmn-mini-logo.2e8d04e5.webp";